export default __webpack_public_path__ + "static/media/4.6225c571.png";